import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Container } from './styles';

const SplashScreen: React.FC = () => (
  <Container>
    <div className="space-y-4 py-8">
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-32 w-full" />
      <Skeleton className="h-32 w-full" />
    </div>
  </Container>
);

export default SplashScreen;
